export default __webpack_public_path__ + "static/media/about_2.c6f6ef9b.jpg";